import { Box, Text } from "@mantine/core"
import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { currencyFormat } from "../../../utils/currency"
import classes from "./CartDrawer.module.css"

type Props = {
  types: number
  pieces: number
  subtotal: number
  /** Text in the «Урамшуулал» row (price promotions are already inside the unit prices). */
  promotionText: ReactNode
  /** Bundle + threshold discount the order service takes off (POST /ord/cart/preview); 0 hides the row. */
  promoDiscount?: number
  /** Payment-term discount; omitted when no term discount applies. */
  termDiscount?: { label: string; amount: number } | null
  vat: number
  total: number
  /** «Нийт» in the drawer, «Нийт дүн» on the checkout page. */
  totalLabel: string
}

/** Totals block of the cart and the checkout summary (canvas OrdB_Cart / OrdB_Checkout). */
export function CartTotals({ types, pieces, subtotal, promotionText, promoDiscount = 0, termDiscount, vat, total, totalLabel }: Props) {
  const { t } = useTranslation("order")
  return (
    <Box className={classes.totals}>
      <Box className={classes.totalRow}>
        <Text span inherit>{t("cart.subtotal", { types, count: pieces })}</Text>
        <Text span className={classes.amount}>{currencyFormat(subtotal)}</Text>
      </Box>
      <Box className={classes.totalRow}>
        <Text span inherit>{t("cart.promotion")}</Text>
        <Text span inherit>{promotionText}</Text>
      </Box>
      {promoDiscount > 0 && (
        <Box className={classes.totalRow}>
          <Text span inherit>{t("cart.promoDiscount")}</Text>
          <Text span className={classes.amount}>{`−${currencyFormat(promoDiscount)}`}</Text>
        </Box>
      )}
      {termDiscount && termDiscount.amount > 0 && (
        <Box className={classes.totalRow}>
          <Text span inherit>{termDiscount.label}</Text>
          <Text span className={classes.amount}>{`−${currencyFormat(termDiscount.amount)}`}</Text>
        </Box>
      )}
      <Box className={classes.totalRow}>
        <Text span inherit>{t("cart.delivery")}</Text>
        <Text span inherit>{t("cart.deliveryLater")}</Text>
      </Box>
      <Box className={classes.totalRow}>
        <Text span inherit>{t("cart.vat")}</Text>
        <Text span className={classes.amount}>{currencyFormat(vat)}</Text>
      </Box>
      <Box className={classes.grandRow}>
        <Text span className={classes.grandLabel}>{totalLabel}</Text>
        <Text span className={classes.grandValue}>{currencyFormat(total)}</Text>
      </Box>
    </Box>
  )
}
